import { SVGProps, Ref, forwardRef } from 'react';

export const EmojiSmileOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.352 9.723c.247-.273.608-.425.98-.425h5.332c.372 0 .733.152.98.425.26.286.39.705.252 1.142a3.2 3.2 0 0 1-.721 1.211c-.755.804-1.915 1.288-3.177 1.288s-2.422-.484-3.177-1.288a3.2 3.2 0 0 1-.721-1.211 1.16 1.16 0 0 1 .252-1.142m1.189.975q.114.22.301.42c.462.492 1.238.846 2.156.846s1.694-.354 2.156-.846q.187-.2.301-.42z"
                fill="currentColor"
            />
            <path
                d="M5.665 5.065c-.461 0-.783.155-.988.4-.202.243-.278.56-.278.867s.076.623.278.865c.205.246.527.4.988.4.462 0 .784-.154.988-.4.202-.242.279-.559.279-.865 0-.307-.077-.624-.279-.866-.204-.246-.526-.4-.988-.4"
                fill="currentColor"
            />
            <path
                d="M10.33 5.065c-.46 0-.783.155-.987.4-.202.243-.279.56-.279.867s.077.623.279.865c.204.246.526.4.988.4s.783-.154.988-.4c.202-.242.278-.559.278-.865 0-.307-.076-.624-.278-.866-.205-.246-.527-.4-.988-.4"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 .5C1.438.5.5 1.438.5 8s.938 7.5 7.5 7.5 7.5-.937 7.5-7.5S14.563.5 8 .5M2.125 4.319C1.96 5.192 1.9 6.37 1.9 8s.06 2.808.225 3.681c.162.86.4 1.287.654 1.54.253.253.68.492 1.54.654.873.165 2.051.225 3.681.225s2.808-.06 3.681-.225c.86-.162 1.287-.4 1.54-.654.253-.253.492-.68.654-1.54.165-.873.225-2.051.225-3.681s-.06-2.808-.225-3.681c-.162-.86-.4-1.287-.654-1.54-.253-.253-.68-.492-1.54-.654C10.808 1.96 9.63 1.9 8 1.9s-2.808.06-3.681.225c-.86.162-1.287.4-1.54.654-.253.253-.492.68-.654 1.54"
                fill="currentColor"
            />
        </g>
    </svg>
));
EmojiSmileOutlinedSize16Glyph.displayName = 'EmojiSmileOutlinedSize16Glyph';
